<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-CE">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="CE" clip-path="url(#clip-CE)">
            <rect width="36" height="36" opacity="0"/>
            <g id="Group_3" data-name="Group 3" transform="translate(7378.76 -627.586)">
                <rect id="Rectangle_10110" data-name="Rectangle 10110" width="36" height="36" transform="translate(-7378.76 627.586)" fill="#263238" opacity="0"/>
                <g id="Group_14560" data-name="Group 14560" transform="translate(-7775.76 229.586)">
                    <path id="Path_1962" :class="svgFillClass" data-name="Path 1962" d="M403,404h24v24H403V404Z"  fill-rule="evenodd" opacity="0"/>
                    <path id="Path_1963" :class="svgFillClass" data-name="Path 1963" d="M415.022,447.963V450.4h0c-.271.026-.547.041-.827.041a8.225,8.225,0,1,1,0-16.448c.28,0,.556.015.827.041h0v2.437h0a5.942,5.942,0,0,0-.827-.058,5.805,5.805,0,1,0,0,11.609,5.942,5.942,0,0,0,.827-.058Z" transform="translate(-2.478 -26.217)"  fill-rule="evenodd"/>
                    <path id="Path_1964" :class="svgFillClass" data-name="Path 1964" d="M522.546,440.962h4.829v2.513h-4.829a5.892,5.892,0,0,0,5.759,4.546,5.986,5.986,0,0,0,.83-.058h0V450.4h0c-.273.026-.55.041-.83.041a8.225,8.225,0,1,1,0-16.448c.28,0,.556.015.83.041h0v2.437h0a6.017,6.017,0,0,0-.83-.058,5.892,5.892,0,0,0-5.759,4.549Z" transform="translate(-102.491 -26.217)"  fill-rule="evenodd"/>
                </g>
            </g>
        </g>
    </svg>

</template>

<script>

export default {
    name: "ceIcon",
    props: {
        svgFillClass: {
            type: String,
            default: 'svg-secondary-color'
        },

    },

}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/ceIcon.vue